import { Icon } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { CELL_AFFORDANCE, CellValueWithAffordance, stopCellClick } from './cellAffordance';
import { EmptyValue } from './EmptyValue';

export function EmailDisplay() {
  const { value, linkAsIcon, listRow } = useFieldContext();
  if (typeof value !== 'string' || value.length === 0) {
    return <EmptyValue />;
  }

  // In an EDITABLE cell the value is plain text and the mail app is one icon away (P1-8).
  if (linkAsIcon === true) {
    return (
      <CellValueWithAffordance
        affordance={
          <a
            href={`mailto:${value}`}
            aria-label={`Write to ${value}`}
            className={CELL_AFFORDANCE}
            onClick={stopCellClick}
          >
            <Icon name="mail" size="0.85rem" />
          </a>
        }
      >
        {value}
      </CellValueWithAffordance>
    );
  }

  // IN A LIST ROW THE ROW IS THE LINK (P4 round 2, finding F5): see `FieldContext.listRow`.
  if (listRow === true) {
    return <span className="block truncate">{value}</span>;
  }

  // No underline under the pointer: the rule and its source are in `UrlDisplay`.
  return (
    <a
      href={`mailto:${value}`}
      className="block truncate text-accent"
      // A tap inside a row must not also open the record behind it.
      onClick={stopCellClick}
    >
      {value}
    </a>
  );
}
